<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="seismicclaimtypeForm">
      <div class="">
        <h3 class="form_name">SeismicClaimType</h3>
  
  
          <div class="input">
            <label for="">ClaimType Name</label>
            <input type="text" class="default_input reference-form" formControlName="ClaimTypeName" />
          </div>
          <div class="input">
            <label for="">Claim Address</label>
            <input type="text" class="default_input reference-form" formControlName="ClaimAddress" />
          </div>
          <div class="input">
            <label for="">ClaimType Email</label>
            <input type="text" class="default_input reference-form" formControlName="ClaimTypeEmail" />
          </div>
          <div class="input">
            <label for="">Claim PhoneNo</label>
            <input type="text" class="default_input reference-form" formControlName="ClaimPhoneNo" />
          </div>
  
        <div class="btn_holder">
          <button class="default_primary-button" (click)="addNew(seismicclaimtypeForm.value)">Add</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for SeismicClaimType"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(seismicclaimtypes | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectSeismicClaimType(option.id)"
                  *ngFor="let option of result"
                  [value]="option.ClaimTypeName"
                >
                  {{ option.ClaimTypeName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">ClaimType Name</span>
          <span class="item">Claim Address</span>
          <span class="item">ClaimType Email</span>
          <span class="item">Claim PhoneNo</span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let seismicclaimtype of seismicclaimtypeFormArray.get('SeismicClaimTypes')['controls']; index as i"
        (click)="onEdit(i, seismicclaimtype.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{seismicclaimtype.value.ClaimTypeName}}</span>
           <span class="content">{{seismicclaimtype.value.ClaimAddress}}</span>
           <span class="content">{{seismicclaimtype.value.ClaimTypeEmail}}</span>
           <span class="content">{{seismicclaimtype.value.ClaimPhoneNo}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteSeismicClaimType(i, seismicclaimtype.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(seismicclaimtypeFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  